<template>
  <section>
    <h1>
      How does <span class="highlight">YOUR</span> salary compare to the
      <span class="highlight"> top gaming stars </span>?
    </h1>

    <p>
     Being paid to play videogames is the dream job for many, but how 
     much are the world's most successful gaming streamers and professional 
     esports athletes making from ad revenue and competition prize money?<br><br>
    Use our inbuilt salary calculator to see how your earnings compare to the biggest names in gaming.. 
    </p>
  </section>
</template>

<style lang="scss" scoped>
section {
  margin-bottom:80px;
  padding: 0px 20px 0px 20px;
}
.highlight {
  color: $orange;
}
</style>